import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import initializers from '../../dependencies/initializers.js'



import imgHero from '../../images/hero_img_technical.png'
import imgSectionOne from '../../images/img_technical_01.png'
import imgSectionTwo from '../../images/img_technical_02.png'
import imgSectionThree from '../../images/img_technical_03.png'
import imgRoundedLeftTop from '../../images/rounded_left_top.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'
import { getWeeklyDemoDataAsync } from '../../actions/global';

class Technical extends React.Component {
  constructor(props) {
    super(props)
  }

	async componentDidMount() {
		window.scrollTo(0, 0)
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync();
    }
	}

  chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

  render() {
    const {
      globalGetLanguages,
      user, weeklyDemoData
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
  
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text apis">
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'TECHNICAL_BANNER_1'))}</div>
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'TECHNICAL_BANNER_2'))}</div>
              
              <p className='sub-title-1' style={{ marginTop: '20px' }}>
                  Select People Who Can Do the Work, Not Just Talk About It
                </p>

              <div className='content-desc-technical'>
                {renderHTML(translate(globalGetLanguages,'TECHNICAL_DESC_BANNER'))}
              </div>

              <div className={`ban-link`}>
                <Link onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('talent-acquisition/technical', 'button_talk_to_an_expert');
                }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  onClick={() => accesslog('talent-acquisition/technical', 'button_register_for_demo')}
                >Register for Demo</a>
              </div>
              <div className={`ban-link hide`}>
                <Link className='try'>{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-left-top">
            <img src={imgRoundedLeftTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionOne} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc-point'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                {renderHTML(translate(globalGetLanguages,'TECHNICAL_BANNER_TITLE_1'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_DESC_1'))}</p>
                  <p style={{ fontSize: '18px' }}>{renderHTML(translate(globalGetLanguages,'TEXT_COMMON_CHALLENGES'))}</p>
                  <ul>
                    <li><i className="fa fa-circle" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_1_SUB_1'))}</li>
                    <li><i className="fa fa-circle" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_1_SUB_2'))}</li>
                    <li><i className="fa fa-circle" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_1_SUB_3'))}</li>
                    <li><i className="fa fa-circle" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_1_SUB_4'))}</li>
                   
                  </ul>                 
                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>            
            <div className='flex-item-right-technical'>
              <div className='vertical-item--center'>
                <div className='sec-desc-point'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                  {renderHTML(translate(globalGetLanguages,'TECHNICAL_BANNER_TITLE_2'))}

                  </h2>
                  <p style={{ fontSize: '18px' }} className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_DESC_2'))}</p>
                   <p style={{ fontSize: '18px' }}>{renderHTML(translate(globalGetLanguages,'TEXT_ASSESSMENT_TYPE'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_2_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_2_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_2_SUB_3'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_2_SUB_4'))}</li>
                  </ul>
                  <p style={{ fontSize: '16px' }}>{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_DESC'))}</p>
                </div>
              </div>
            </div> 

            <div className='flex-item-left-technical'>
              <div className='vertical-item--center'>
                <img className='img-100' src={imgSectionTwo} />
              </div>
            </div>


          </section>
      </div>

     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionThree} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                  {renderHTML(translate(globalGetLanguages,'TECHNICAL_BANNER_TITLE_3'))}
                  </h2>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_3_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_3_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_3_SUB_3'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_TECHNICAL_FEATURE_3_SUB_4'))}</li>
                  </ul>
                </div>
              </div>
            </div> 
          </section>
      </div>

      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Bring Structure to Every Technical Hire</h1>
              <h4>With ASTRNT, hiring for technical roles becomes more consistent, more efficient, and based on what really matters. <br />You can focus on reviewing real results and make decisions with confidence.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('talent-acquisition/technical', 'button_talk_to_an_expert')
                  }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                  <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                    onClick={() => accesslog('talent-acquisition/technical', 'button_register_for_demo')}
                  >Register for Demo</a>
                </div>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData 
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Technical)
